// @flow
import { takeEvery, put, call, select } from 'redux-saga/effects';
import unionBy from 'lodash/unionBy';
import type { FilesActionType } from './actions';
import { setFiles } from './actions';
import { filesSelector } from './selectors';
import { setLoading } from '../LoadingStatus/actions';
import { tripica } from '../../api';
import HandleErrorService from '../../lib/handleError';
import WizzeeLog from '../../lib/wizzeeLog';

export function* fetchFiles(action: FilesActionType): Generator<*, *, *> {
  if (action.type !== 'FETCH_FILES') {
    return;
  }
  yield put(setLoading('fetchFiles', true));

  const { beginDate, endDate } = action.payload;

  try {
    const currentFiles = yield select(filesSelector);

    const files = yield call([tripica, 'getFiles'], beginDate, endDate);

    const mergedFiles = unionBy(currentFiles, files, 'ouid');

    yield put(setFiles(mergedFiles));
  } catch (e) {
    HandleErrorService.showToastError(e);
    WizzeeLog.warn('[saga] fetchFiles', e);
  } finally {
    yield put(setLoading('fetchFiles', false));
  }
}

export default function*(): Generator<*, *, *> {
  yield takeEvery('FETCH_FILES', fetchFiles);
}
